module.exports = __webpack_public_path__ + "img/menu-contributions-icon.4b731049.svg";